<div
  style="
    border: 2px solid #fff;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  "
>
  <div class="p-3">
    <div
      style="
        display: inline-block;
        flex-shrink: 0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: hidden;
      "
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        "
        (mouseenter)="gameHover = true"
        (mouseleave)="gameHover = false"
      >
        <img
          style="
            border: 4px solid transparent;
            width: 100%;
            height: 100%;
            max-width: 100%;
            max-height: 100%;
            border-radius: 0.5rem;
            transition: opacity 0.3s ease;
          "
          src="assets/images/game-logo-01.jpg"
          alt="Juego 01"
          [ngStyle]="{
            border: '2px solid',
            borderColor: colors?.primary,
            opacity: gameHover ? '0.2' : '1'
          }"
        />
        <div
          style="
            position: absolute;
            inset: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: opacity 0.3s ease;
            z-index: 10;
          "
          [ngStyle]="{
            opacity: gameHover ? '1' : '0'
          }"
        >
          <span
            [ngStyle]="{
              backgroundColor: colors?.primary
            }"
            style="
              font-weight: 500;
              padding: 0.2rem 0.8rem;
              border-radius: 0.5rem;
              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
              color: #000;
              cursor: pointer;
              font-weight: bold;
            "
            >JUGAR</span
          >
        </div>
      </div>
    </div>
  </div>
  <div style="grid-column: span 2" class="p-3">
    <div class="flex justify-content-between">
      <h2
        style="
          font-size: 1.2rem;
          line-height: 2rem;
          font-weight: 600;
          margin: 0;
        "
      >
        Table
      </h2>
      <div style="margin-bottom: 0.5rem">
        <div class="relative" style="width: 100%">
          <select
            [ngStyle]="{
              backgroundColor: getBackground(1),
              borderColor: !filterFocus ? getBackground(4) : colors?.primary
            }"
            (focus)="filterFocus = true"
            (blur)="filterFocus = false"
            style="
              outline: none;
              border: 1px solid;
              min-width: 90px;
              padding: 0.3rem;
              padding-left: 0.8rem;
              border-radius: 0.5rem;
              width: 100%;
              font-size: 0.875rem;
              line-height: 1.25rem;
              appearance: none;
              cursor: pointer;
              color: #fff;
            "
          >
            <option disabled="" selected="">Filter</option>
            <option value="popular">Option 1</option>
            <option value="newest">Option 2</option>
            <option value="rating">Option 3</option>
          </select>
          <div
            style="
              display: flex;
              position: absolute;
              top: 0;
              bottom: 0;
              right: 0.75rem;
              align-items: center;
              pointer-events: none;
            "
          >
            <svg
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              [ngStyle]="{ color: colors?.primary }"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div
      [ngStyle]="{ backgroundColor: getBackground(2) }"
      style="border-radius: 0.5rem; margin-bottom: 0.5rem"
      class="p-2"
    >
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          border-top-width: 1px;
          border-color: #4c586c;
        "
      >
        <thead>
          <tr>
            <th style="text-align: left; padding: 0.5rem 0.8rem">
              <span
                style="font-size: 12px"
                class="fa-solid fa-house-chimney"
                [ngStyle]="{ color: colors?.primary }"
              ></span>
              Title 1
            </th>
            <th style="text-align: left; padding: 0.5rem 0.8rem">
              <span
                style="font-size: 12px"
                class="fa-solid fa-user"
                [ngStyle]="{ color: colors?.primary }"
              ></span>
              Title 2
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style="border-top: 1px solid"
            [ngStyle]="{ borderColor: getBackground(4) }"
          >
            <td
              [ngStyle]="{ color: colors?.primary }"
              style="padding: 0.5rem 0.8rem"
            >
              Body 1
            </td>
            <td style="padding: 0.5rem 0.8rem">Body 2</td>
          </tr>
          <tr
            style="border-top: 1px solid; border-bottom: 1px solid"
            [ngStyle]="{ borderColor: getBackground(4) }"
          >
            <td
              [ngStyle]="{ color: colors?.primary }"
              style="padding: 0.5rem 0.8rem"
            >
              Body 1
            </td>
            <td style="padding: 0.5rem 0.8rem">Body 2</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex justify-content-end">
      <button
        [ngStyle]="{
          backgroundColor: btnHover ? colors?.primary : getBackground(3),
          color: btnHover ? 'black' : 'white'
        }"
        (mouseenter)="btnHover = true"
        (mouseleave)="btnHover = false"
        style="
          display: block;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
          padding-left: 1rem;
          padding-right: 1rem;
          border-radius: 0.5rem;
          font-weight: bold;
          text-align: center;
          border: none;
          cursor: pointer;
        "
      >
        Guardar
      </button>
    </div>
  </div>
</div>
